import {Image, Row, Typography, Col, Tooltip} from 'antd'
import React from "react"

export function NotificationItem({title, message, time, relativeTime, buttonText, buttonLink}) {
  return (
    <div className="notification-item profile-widget">
      <Row>
        <Col xs={24} md={24} xl={24}>
          <Row align="center" justify="center">
            <Col xs={24} md={24} xl={24}>
              <Typography.Title className="notification-title mt-0" level={4}>{title}</Typography.Title>
            </Col>
            <Col xs={24} md={24} xl={24}>
              <Typography.Text className="notification-message" level={4}>{message}</Typography.Text>
            </Col>


              <Col xs={24} md={24} xl={24} className="mt-1">
                {time && relativeTime && (
                  <Tooltip title={time}>
                    <Typography.Text className="notification-time fs-smaller" type="secondary">{relativeTime}</Typography.Text>
                  </Tooltip>
                )}

                {buttonText && buttonLink &&
                  <Typography.Link href={buttonLink} className="mt-0" style={{lineHeight: 1.2, textDecoration: 'underline', float: 'right'}}>{buttonText} <span style={{fontFamily: 'Georgia, Helvetica, sans-serif', fontSize: '1.2em'}}> →</span></Typography.Link>
                }
              </Col>

          </Row>
        </Col>
      </Row>
    </div>
  )
}
